<div class="modal-dialog" [attr.role]="'document'">
	<div class="modal-content">
		<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
			<button class="btn btn-default-reverse btn-block btn-sm" [attr.data-dismiss]="'modal'" type="button"
				(click)="createForm();">Chiudi</button>
		</p>
		<div>
			<div class="col-sm-12 coldx">
				<h3 class="title1level" style="margin-bottom: 20px;">Aggiungi {{tipoFascicolo === 'parere' ? 'soggetto richiedente' : 'parte' }}</h3>
				<div class="container_tab_nav">
					<ul class="nav nav-tabs two">
						<li *ngIf="tabsWidth[0] !== 0" [style.width.%]="tabsWidth[0]" class=""><a data-toggle="tab" href="#tabcontent9"
								aria-expanded="true">Copia da precedenti</a></li>
						<li [style.width.%]="tabsWidth[1]" class="active"><a data-toggle="tab" href="#tabcontent7"
								aria-expanded="true">Cerca</a></li>
						<li [style.width.%]="tabsWidth[2]" class=""><a data-toggle="tab" href="#tabcontent8"
								aria-expanded="false">Inserisci</a></li>
					</ul>
					<div class="tab-content">
						<div id="tabcontent9" class="tab-pane fade">
							<div controparti-precedenti-add-form #copiaDaPrecedenti [hidden]="!viewSearchMask"
								(onReturn)="manageModalPrecedenti($event)" (init)="assegnaPrecedenti($event)"></div>
						</div>
						<div id="tabcontent7" class="tab-pane fade active in">
							<div ricerca-anagrafiche-form #formRicercaParte [hidden]="!viewSearchMask"
								(onReturn)="foundedAnagrafica($event)" [isControparte]="true"></div>
							<div *ngIf="isPrd" associativa-controparti-form-add #formAddAssociativaRicerca [isAttore]="flagAttore"
								[hidden]="viewSearchMask" [isPatologia]="isPatologia" (onReturn)="manageModal($event)"
								(onReturnControparte)="manageModalControparte($event)"></div>
						</div>
						<div id="tabcontent8" class="tab-pane fade">
							<div *ngIf="isPrd" parte-anagrafica-form-add #formAddAnagrafica [hidden]="haveNewAnagrafica"
								(onReturn)="newAnagrafica($event)" [isControparte]="true"></div>
							<div *ngIf="isPrd" associativa-controparti-form-add #formAddAssociativaAnagrafica
								[hidden]="!haveNewAnagrafica" [isPatologia]="isPatologia" [isAttore]="flagAttore"
								(onReturn)="manageModal($event)" (onReturnControparte)="manageModalControparte($event)">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
